import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Mall',
    component: () => import('@/views/Mall.vue'),
    meta: {
      title: '遛遛游戏 - 商城',
      keepAlive: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/mall',
    name: 'Mall',
    component: () => import('@/views/Mall.vue'),
    meta: {
      title: '遛遛游戏 - 商城',
      requireAuth: false,
      keepAlive: true,  // 标记需要缓存
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/Order.vue'),
    meta: {
      title: '确认订单',
      requireAuth: false
    }
  },
  {
    path: '/wxAuth',
    name: 'WxAuth',
    component: () => import('@/views/WxAuth.vue'),
    meta: {
      title: '微信登录',
      requireAuth: false
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 检查是否需要登录
  if (to.meta.requireAuth) {
    const token = localStorage.getItem('userToken')
    if (!token) {
      next('/login')
      return
    }
  }

  next()
})

export default router